const ContentTitle: React.FC = () => {
  return (
    <div className='relative z-[1] flex h-[100%] lg:h-[90%]  mx-auto flex-col justify-end'>
      <div className='flex flex-col gap-2 lg:gap-4 pt-[3%] pb-[1%] px-[3%]'>
        <p className=' text-white text-[32px] lg:text-[70px] 2xl:text-[90px] leading-8 lg:leading-[65px] 2xl:leading-[85px] font-bold w-11/12 lg:w-[50%] lg:pr-8 font-play'>
          Разработка  отечественных<span className="text-[#38D548]"> устройств</span> и ПО
        </p>
        <p className=' text-white text-[14px] lg:text-2xl 2xl:text-3xl lg:font-normal lg:pr-8 mt-3 mb-8 lg:mb-0 font-play'>
          Создаем будущее, используя лучшие технологии
        </p>
      </div>
    </div>
  )
}

export default ContentTitle;
